export default "__VITE_ASSET__BANW9kK4__"